<template>
  <div
    class="page_container addEditBrandIncreasePage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/AdvertismentIndex/aManageIndex' }"
          >广告管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>视频广告管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>视频广告管理</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>名称：</p>
            <div class="input_box">
              <el-input v-model="formData.topic" placeholder="名称"></el-input>
            </div>
          </div>
          <div class="product_details_edit">
            <!-- 编辑内容展示 -->
            <div class="product_details_content" v-if="formData.videourl != ''">
              <div class="product_details_item">
                <!-- 子内容操作 -->
                <div class="product_details_item_operate flex-between">
                  <div class="txt">视频</div>
                  <div class="operate_group flex-rowr">
                    <div class="btn flex-rowc" @click="formData.videourl = ''">
                      移除
                    </div>
                  </div>
                </div>
                <div class="product_details_item_content">
                  <!-- 视频 -->
                  <div class="video_box">
                    <div @click="openFileInputVideo(item.id)">
                      <video :src="formData.videourl" controls></video>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 编辑操作 -->
            <div
              class="product_details_operate flex-between"
              v-if="formData.videourl == ''"
            >
              <div class="txt">内容</div>
              <div class="operate_group flex-rowr">
                <div class="btn flex-rowc" @click="openFileInputVideo('')">
                  + 新增视频内容
                </div>
              </div>
            </div>
            <input
              type="file"
              ref="fileInputVideo"
              style="display: none"
              @change="addVideoContent"
              accept="video/*"
            />
          </div>
          <div class="block">
            <p>排序：</p>
            <div class="input_box">
              <el-input v-model="formData.sortno" placeholder="排序"></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>跳转类型：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.gotype"
                style="justify-content: space-evenly"
              >
                <el-radio label="3">不跳转</el-radio>
                <el-radio label="1">HTTP(HTTPS)链接</el-radio>
                <el-radio label="4">本体小程序内部路径path</el-radio>
                <el-radio label="2">第三方小程序</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 1">
            <p><span class="mark">*</span>链接：</p>
            <div class="input_box">
              <el-input
                v-model="formData.HttpsUrl"
                placeholder="链接"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 4">
            <p><span class="mark">*</span>内部路径：</p>
            <div class="input_box">
              <el-input
                v-model="formData.InUrl"
                placeholder="内部路径"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 2">
            <p><span class="mark">*</span>第三方小程序AppID：</p>
            <div class="input_box">
              <el-input
                v-model="formData.otherappid"
                placeholder="第三方小程序AppID"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 2">
            <p><span class="mark">*</span>第三方小程序原始ID：</p>
            <div class="input_box">
              <el-input
                v-model="formData.otherappid_ori"
                placeholder="第三方小程序原始ID"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 2">
            <p><span class="mark">*</span>小程序路径：</p>
            <div class="input_box">
              <el-input
                v-model="formData.otherapppath"
                placeholder="小程序路径"
              ></el-input>
            </div>
          </div>
          <div class="block" v-if="formData.gotype == 2">
            <p>备用Url：</p>
            <div class="input_box">
              <el-input
                v-model="formData.otherappurl"
                placeholder="备用Url"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>状态：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.astate"
                style="justify-content: space-evenly"
              >
                <el-radio label="启用">启用</el-radio>
                <el-radio label="停用">停用</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
// import axios from "axios";
import {
  getAdverVideoDetail,
  // uploadImage,
  addAdverVideo,
  editAdverVideo,
  encryptstringview,
  // getUploadToken,
} from "../../api/api";
import { getVideoToken, uploadVideoOss } from "../../utils/oss";
import { mapState } from "vuex";
export default {
  name: "adverVideo",
  data() {
    return {
      qyid: 0,
      id: "",

      loading: false,
      formData: {
        id: "",
        qyguid: "",
        topic: "",
        videourl: "",
        sortno: "",
        gotype: "",
        HttpsUrl: "",
        InUrl: "",
        otherappid: "",
        otherappid_ori: "",
        otherapppath: "",
        otherappurl: "",
        astate: "停用",
      },
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.formData.qyguid = USERINFO.qy.qyguid;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        if (id) {
          this.formData.id = id;
          this.init(id);
        }
      } else {
        this.$router.back();
      }
    },

    init(id) {
      this.loading = true;
      getAdverVideoDetail({ id }).then((res) => {
        this.formData.topic = res.topic;
        this.formData.videourl = res.videourl ? res.videourl : "";
        this.formData.sortno = res.sortno;
        this.formData.gotype = res.gotype ? res.gotype : "";
        this.formData.HttpsUrl = res.HttpsUrl;
        this.formData.InUrl = res.InUrl;
        this.formData.otherappid = res.otherappid;
        this.formData.otherappid_ori = res.otherappid_ori;
        this.formData.otherapppath = res.otherapppath;
        this.formData.otherappurl = res.otherappurl;
        this.formData.astate = res.astate ? res.astate : "停用";
        this.loading = false;
      });
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "aManageIndex" });
    },
    // 3、新增视频内容
    openFileInputVideo(id) {
      this.editId = id;
      this.$refs.fileInputVideo.click();
    },
    async addVideoContent(e) {
      this.loading = true;
      let file = e.target.files[0];
      try {
        let { data } = await getVideoToken();

        let { status } = await uploadVideoOss(data, file);
        if (status == 200) {
          let url = data.pubilic_url;
          this.formData.videourl = url;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        // console.error("Upload failed:", error);
      }
    },
    // 设置上传进度
    setUploadProgress(event) {
      // 进度处理逻辑
      const progress = Math.round((event.loaded / event.total) * 100);
      this.loadingText = `上传:${progress}%`;
      if (progress == 100) {
        this.loading = false;
      }
    },

    query() {
      let { formData } = this;
      if (formData.topic == "") {
        this.$message.warning("请输入名称");
        return;
      }
      if (formData.videourl == "") {
        this.$message.warning("请上传视频");
        return;
      }
      if (formData.sortno == "") {
        this.$message.warning("请输入排序");
        return;
      }
      if (formData.gotype == "") {
        this.$message.warning("请选择跳转类型");
        return;
      }
      if (formData.gotype == 1 && formData.HttpsUrl == "") {
        this.$message.warning("请输入链接");
        return;
      }
      if (formData.gotype == 4 && formData.HttpsUrl == 4) {
        this.$message.warning("请输入内部路径");
        return;
      }
      if (formData.gotype == 2) {
        if (formData.otherappid == "") {
          this.$message.warning("请输入第三方小程序AppID");
          return;
        }
        if (formData.otherappid_ori == "") {
          this.$message.warning("请输入第三方小程序原始ID");
          return;
        }
        if (formData.otherapppath == "") {
          this.$message.warning("请输入小程序路径");
          return;
        }
        if (formData.otherappurl == "") {
          this.$message.warning("请输入备用Url");
          return;
        }
      }
      if (formData.id == "") {
        this.loading = true;
        addAdverVideo(formData).then((res) => {
          if (res.result) {
            // this.$toast.success(res.message);
            // setTimeout(() => {
            //   // this.clearData();
            //   history.back();
            // }, 1500);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            // this.clearData();
            this.$message.error(res.message);
          }
        });
      } else {
        this.loading = true;
        editAdverVideo(formData).then((res) => {
          if (res.result) {
            this.$message.success(res.message);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    clearData() {
      this.formData.labelname = "";
      this.formData.radio = "";
      this.formData.linkurl = "";
      this.formData.apppath = "";
      this.formData.labelstate = "";
      this.formData.labelcont_y = "";
      this.formData.labelcont_m = "";
      this.formData.labelcont_t = "";
      this.formData.logo = "";
      this.formData.sort = "";
    },
  },
};
</script>
<style lang="less" scoped>
.addEditBrandIncreasePage {
  .product_details_edit {
    width: 100%;
    padding: 0 0 70px;
    font-size: 20px;
    color: #505050;
    .product_details_content {
      box-sizing: border-box;
      margin-bottom: 20px;
      .product_details_item {
        .product_details_item_operate {
          width: 100%;
          height: 50px;
          border: 1px solid #d2d2d2;
          font-size: 14px;
          padding: 0 22px;
          box-sizing: border-box;
          .txt {
            font-size: 16px;
          }
          .operate_group {
            .btn {
              border: 1px solid #d2d2d2;
              height: 25px;
              padding: 0 14px;
              margin-left: 20px;
              cursor: pointer;
              &.disable {
                color: #c1c1c1;
              }
            }
          }
        }
        .product_details_item_content {
          padding: 0 12px 40px;
          .txt_box {
            min-height: 150px;
            .van-cell {
              padding: 0;
            }
          }
          .pic_box,
          .video_box {
            padding-top: 25px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
    .product_details_operate {
      border: 1px solid #d2d2d2;
      padding: 15px 20px 20px;
      .txt {
        font-size: 16px;
        white-space: nowrap;
      }
      .btn {
        font-size: 14px;
        color: #ffffff;
        height: 30px;
        background: #1e1e1e;
        padding: 0 6px;
        white-space: nowrap;
        cursor: pointer;
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
    }
  }
}
</style>